import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

const testimonials = [
  { id: 1, src: '/images/testimonials/Miss-B.-Brighton.gif', alt: 'Miss B., Brighton' },
  { id: 2, src: '/images/testimonials/Mr-B.-Brighton.gif', alt: 'Mr B., Brighton' },
  { id: 3, src: '/images/testimonials/Mr-C.-Shoreham.gif', alt: 'Mr C., Shoreham' },
  { id: 4, src: '/images/testimonials/Mr-J-Hove.gif', alt: 'Mr J., Hove' },
  { id: 5, src: '/images/testimonials/Mr-K-Brighton.gif', alt: 'Mr K., Brighton' },
  { id: 6, src: '/images/testimonials/Mr-K.-Brighton.-2.gif', alt: 'Mr K., Brighton' },
  { id: 7, src: '/images/testimonials/Mr-P.-Brighton-(e-mail).gif', alt: 'Mr P., Brighton' },
  { id: 8, src: '/images/testimonials/Mr-Y.-Hove..gif', alt: 'Mr Y., Hove' },
  { id: 9, src: '/images/testimonials/Mrs-R.-Worthing..gif', alt: 'Mrs R., Worthing' },
  { id: 10, src: '/images/testimonials/Ms-E.-Brighton.gif', alt: 'Ms E., Brighton' },
]

function TestimonialsScroll() {
  const [isPaused, setIsPaused] = useState(false)
  
  // Duplicate the testimonials for seamless infinite scroll
  const duplicatedTestimonials = [...testimonials, ...testimonials]

  return (
    <div className="w-full overflow-hidden bg-gradient-to-b from-white to-accent/20 py-16">
      <div className="container mx-auto px-4 mb-8">
        <h2 className="text-3xl font-bold text-center mb-2">What Our Customers Say</h2>
        <p className="text-center text-muted-foreground">Genuine handwritten testimonials from satisfied customers</p>
      </div>
      
      <div 
        className="relative"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="flex">
          <motion.div
            className="flex gap-6"
            animate={{
              x: isPaused ? 0 : '-50%',
            }}
            transition={{
              x: {
                duration: 60,
                repeat: Infinity,
                ease: 'linear',
              },
            }}
          >
            {duplicatedTestimonials.map((testimonial, index) => (
              <div
                key={`${testimonial.id}-${index}`}
                className="flex-shrink-0 w-80 h-96 bg-white rounded-lg shadow-lg p-4 hover:shadow-xl transition-shadow"
              >
                <img
                  src={testimonial.src}
                  alt={testimonial.alt}
                  className="w-full h-full object-contain"
                />
              </div>
            ))}
          </motion.div>
        </div>
        
        {/* Gradient overlays for smooth edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent pointer-events-none z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent pointer-events-none z-10" />
      </div>
      
      <div className="text-center mt-8">
        <p className="text-sm text-muted-foreground">Hover to pause and read</p>
      </div>
    </div>
  )
}

export default TestimonialsScroll